import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../core/animations';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { TypeEmployeeService } from '../../../../../services/type-employee/type-employee.service';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../../../environments/environment';


@Component({
    selector: 'fuse-print-shift',
    templateUrl: './print-shift.component.html',
    styleUrls: ['./print-shift.component.scss'],
    animations: fuseAnimations
})
export class PrintShiftComponent implements OnInit {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;

    public shifts = [];
    confirmDialogRef: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PrintShiftComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        public dialog: MatDialog,
    ) {
        console.log('FuseAddStudentComponent > data', data);
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.shiftService.getAll()
        ).subscribe(([shifts]) => {
            this.shifts = shifts.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false, Disabled: false};
            });
            this.shifts = this.shifts.filter(s => this.data.shifts.indexOf(s.Id) !== -1);
            this.shifts.forEach(s => {
                const concept = this.data.employee[s.Id];
                if (!(concept && concept > 0)) {
                    s.Disabled = true;
                    s.Description = s.Description + ' (No se cargó concepto)';
                }
            });
            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    required(list) {
        return list.filter(e => e.Checked).length === 0;
    }


    save() {
        const shifts = this.shifts.filter(e => e.Checked).map(e => e.Id);
        window.open(environment.backendUri + 'report/teachingProfesionalConcept/' + this.data.employee.Id + '/' + this.data.schoolYearId + '/' + shifts, '_new');
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/professional-concept/print-shift/print-shift.component.ts